export enum EHWCameraErrors {
    NONE = 0,
    CONSTRAINTS = 1,
    PERMISSIONS = 2,
    NOVIDEODEVICES = 3,
    ALREADYUSED = 4,
    OTHER = 5
}
